// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ArticleCard_cardContainer__Fmlvd redesign-shadows_elevation2__1u6CJ","textContainer":"ArticleCard_textContainer__7SAbo"};